import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import EtaBox from './live_order_stream_panel_eta_box'
import ShopName from './shop_name'
import {observer, inject} from 'mobx-react';

const mainShopLogo = {
    "marginRight": "10px",
    "marginLeft": "10px",
    "borderRadius": "50%"
};

function isMultiLineShopName(nameLength) {
    return nameLength > 30 ? true : false;
}

@inject('RootStore')
@observer
export default class LiveOrderStreamPanelHeader extends Component {
    render() {
        const {configStore, styleStore, orderStore} = this.props.RootStore
        const {isShopOpen} = configStore

        let etaBox = <EtaBox/>;
        let shopNameWidth = '74.5%';
        if(!isShopOpen || orderStore.mainShopData.hide_eta || configStore.displayOfflineMode) {
            etaBox = "";
            shopNameWidth = '96%';
        }
        let multiLineShopName = isMultiLineShopName();
        const logoSize = this.props.parentContainerHeight * styleStore.currentLiveStreamOrderStyle.logoRelativeSizeToParent
        const panelHeaderStyle = {paddingTop: styleStore.currentLiveStreamOrderStyle.panelHeaderPaddingTop}
        return (
          <Flexbox height="100%" width="100%" flexDirection="row"
                   alignItems={"center"} style={panelHeaderStyle}>
              <img src={orderStore.mainShopData.image}
                   width={`${logoSize}px`}
                   height={`${logoSize}px`}
                   style={mainShopLogo} alt=""/>
              <ShopName mainDivWidth={shopNameWidth} multiLineShopName={multiLineShopName}
                        name={orderStore.mainShopData.name}/>
              {etaBox}
          </Flexbox>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/live_order_stream_panel/live_order_stream_panel_header.jsx